export default __webpack_public_path__ + "static/media/Icons_Transaction Icon.03bdbfdd.svg";